///<reference path='../../typings/index.d.ts' />
///<reference path='pixilayer.ts' />
///<reference path='splitsprite.ts' />
///<reference path='../manifest/assets.ts' />
///<reference path='../utils/general.ts' />
///<reference path='../utils/transform.ts' />
///<reference path='../utils/spriteutils.ts' />
///<reference path='../scenemanager.ts'/>



module agi.expressions.card.layer{

    import AssetManifest = agi.expressions.card.manifest.AssetManifest;
    import TransformUtils = agi.expressions.card.utils.TransformUtils;
    import SpriteUtils = agi.expressions.card.utils.SpriteUtils;
    import ObjectType = agi.expressions.card.manifest.ObjectType;
    import utils = agi.expressions.card.utils;

    /**
     * Base class representing a HiddenObject Game. This class sets you up with some boilerplate code to get going, but not a lot! 
     * Main aspect to look into is the buildObjects method.
     */
    export class HOGBaseScene extends PixiLayer{

        protected renderer:PIXI.WebGLRenderer|PIXI.CanvasRenderer;
        protected assetManifest:AssetManifest;
        protected personalizations:any;

        protected sceneContainer : PIXI.Container;

        protected configIndex : number = 0;


        public init(options:SceneOptions){
            this.renderer = options.renderer;
            this.assetManifest = options.assetManifest;
            this.personalizations = options.personalizations;


            // ***********************************************
            // sceneContainer
            // The 'stage' for all visual assets of the game.
            // UI and HOG game will go in here.
            // *********************************************** 
            this.sceneContainer = new PIXI.Container();
        }

        /**
         * Build the hidden objects, props, etc. using the asset manifest
         * @param objContainer Container in which every object will be added to
         * @param onHiddenObjFound Method to invoke when a hidden object is found
         * @param containerLists 2D array of PIXI containers. **The length of this must be equal to the number of enumerators of the ObjectType enum**, found in AssetManifest. They'll be placed in arrays in this order.
         * @example
         * let objContainer = new PIXI.Container();
         * let onHiddenObjFound = () => console.log("found!");
         * let hiddenObjs = [], foreground = [], props = []; //ObjectType enum is {HiddenObjects, Foreground, Props}
         * buildObjects(objContainer, onHiddenObjFound, [hiddenObjs, foreground, props]);
         */
        protected buildObjects(objContainer: PIXI.Container,  onHiddenObjFound : ()=>void, containerLists : Array<Array<PIXI.Container>>){
            this.configIndex = Math.floor(Math.random() * this.assetManifest.levelConfigurations.length);
            let groupPath = this.assetManifest.groupUrls[this.configIndex];
            let levelConfig = this.assetManifest.levelConfigurations[this.configIndex];

            /**
             * Create a HiddenObj based on the current for-loop iteration
             */
            let makeHiddenObj = (containingList:PIXI.Container[], objectConfig) => {
                let sprPath = groupPath+objectConfig.name+this.assetManifest.objectFileExt;

                if (!(sprPath in PIXI.utils.TextureCache))
                    throw `${sprPath} not in Texture Cache.`;

                let hideSprite = PIXI.Sprite.fromFrame(sprPath);
                //resize the hitareas of the hidden object
                hideSprite.hitArea = new PIXI.Rectangle(0,0,0,0);

                let foundSprite = PIXI.Sprite.fromFrame(groupPath + "glow/" + objectConfig.name + this.assetManifest.objectFileExt);
                let aHiddenObj:HiddenObj = new HiddenObj(hideSprite, foundSprite, onHiddenObjFound);
                
                aHiddenObj.position.set(objectConfig.x, objectConfig.y);
                aHiddenObj.name = objectConfig.name;

                //set pivot in the middle for this and all children
                let pivot = new PIXI.Point(aHiddenObj.hideSprite.width/2, aHiddenObj.hideSprite.height/2);
                TransformUtils.setPivotAndMaintainVisualPositionRecursively(pivot, aHiddenObj);

                containingList.push(aHiddenObj);
                objContainer.addChild(aHiddenObj);
            }

            /**
             * Make a non-hidden object and add it to the provided container
             */
            let makeNonHiddenObj = (containingList:PIXI.Container[], objectConfig) => {

                let sprPath = `${ObjectType[objectConfig.type]}/${objectConfig.name}`;
                let obj = utils.makeGeneralizedSprite(sprPath); 
                //set position
                obj.position.set(objectConfig.x, objectConfig.y);
                //name it
                obj.name = objectConfig.name;
                //disable interactivity 
                obj.hitArea = new PIXI.Rectangle(0,0,0,0);
                //add to container
                containingList.push(obj);
                objContainer.addChild(obj);
            }   

            /**
             * Based on the objectConfig's type, build the appropriate object
             */
            let buildObjectByType = (objectConfig) => {
                switch (objectConfig.type){
                    case ObjectType.HiddenObject: 
                        makeHiddenObj(containerLists[0], objectConfig);
                        break;
                    case ObjectType.foreground: 
                        makeNonHiddenObj(containerLists[1], objectConfig);
                        break;
                    case ObjectType.props:
                        makeNonHiddenObj(containerLists[2], objectConfig);
                        break;
                    default:
                        throw `Unsupported Asset Type: ${objectConfig.type} !`;
                }
            }

            //loop thru asset manifest
            for(let objectConfig of levelConfig.objectConfigs){
                buildObjectByType(objectConfig);
            }            
        }
    }
}